import ContactUs from '~/components/modal-windows/ContactUs.vue'
import ExportIncreasedRatesStatistics
  from '~/components/modal-windows/export/statistics/ExportIncreasedRatesStatistics.vue'
import ExportOrdersStatistics from '~/components/modal-windows/export/statistics/ExportOrdersStatistics.vue'
import ExportPaidOrdersAndUsersStatistics
  from '~/components/modal-windows/export/statistics/ExportPaidOrdersAndUsersStatistics.vue'
import ExportSalesStatistics from '~/components/modal-windows/export/statistics/ExportSalesStatistics.vue'
import UpdateBrandPositions from '~/components/modal-windows/scripts/UpdateBrandPositions.vue'
import UpdateProductPositions from '~/components/modal-windows/scripts/UpdateProductPositions.vue'
import UpdateThisWeekDiscounts from '~/components/modal-windows/scripts/UpdateThisWeekDiscounts.vue'
import constants from '~/constants/index'
import AuthScope from '~/enums/auth-scope'
import Page from '~/enums/page'
import UserPermission from '~/enums/user-permission'
import type { CatalogMenuItem, HorizontalMenuItem, MenuItem } from '~/types/menus'

const {
  blackFriday,
  forAnimals,
  // greenFriday,
  groceries,
  iherb,
  // motherDay,
  // octoberFest,
  peptides,
  sale1111
} = constants.categories

const account: MenuItem[] = [
  { icon: 'outlined/inventory-2', name: 'История заказов', path: Page.AccountOrders },
  { icon: 'outlined/list-alt', name: 'Списки', path: Page.AccountLists },
  { icon: 'outlined/question-answer', name: 'Консультации', path: Page.AccountConsultations },
  { icon: 'outlined/recommend', name: 'Рекомендации', path: Page.AccountRecommendations },
  { icon: 'outlined/location-on', name: 'Адреса', path: Page.AccountAddresses },
  { icon: 'outlined/settings', name: 'Настройки', path: Page.AccountSettings },
  {
    icon: 'outlined/ticket-percent-outline',
    isUsualLink: true,
    name: 'Скидки в\xA0лабораториях',
    path: constants.documentUrls.coupons
  }
]
const admin: MenuItem[] = [
  // {
  //   icon: 'outlined/dashboard',
  //   name: 'Дашборд',
  //   path: Page.AdminDashboard
  //   // userPermission: UserPermission.GetUsers
  // },
  {
    icon: 'outlined/people',
    name: 'Пользователи',
    path: Page.AdminUsers,
    userPermission: UserPermission.GetUsers
  },
  {
    icon: 'outlined/people',
    name: 'Амбассадоры',
    path: Page.AdminAmbassadors,
    userPermission: UserPermission.GetAmbassadors
  },
  {
    icon: 'outlined/people',
    name: 'Специалисты',
    path: Page.AdminSpecialists,
    userPermission: UserPermission.AdminGetSpecialists
  },
  {
    icon: 'outlined/question-answer',
    name: 'Консультации',
    path: Page.AdminConsultations,
    userPermission: UserPermission.AdminGetConsultations
  },
  {
    icon: 'outlined/inventory-2',
    name: 'Заказы',
    path: Page.AdminOrders,
    userPermission: UserPermission.GetOrders
  },
  {
    icon: 'outlined/widgets',
    name: 'Товары',
    path: Page.AdminProducts,
    userPermission: UserPermission.AdminGetProducts
  },
  {
    icon: 'outlined/category',
    name: 'Категории',
    path: Page.AdminCategories,
    userPermission: UserPermission.GetCategoriesAsAdmin
  },
  {
    icon: 'outlined/branding-watermark',
    name: 'Бренды',
    path: Page.AdminBrands,
    userPermission: UserPermission.AdminGetBrands
  },
  {
    icon: 'outlined/store',
    name: 'Поставщики',
    path: Page.AdminSuppliers,
    userPermission: UserPermission.AdminGetSuppliers
  },
  {
    icon: 'outlined/store',
    name: 'Заявки поставщиков',
    path: Page.AdminSupplierApplications,
    userPermission: UserPermission.AdminGetSupplierApplications
  },
  {
    icon: 'outlined/article',
    name: 'FAQ для поставщиков',
    path: Page.AdminSupplierFaqs,
    userPermission: UserPermission.AdminGetSupplierFaqs
  },
  {
    icon: 'outlined/article',
    name: 'Заявки на\xA0поставку',
    path: Page.AdminSupplyOrders,
    userPermission: UserPermission.AdminGetSupplyOrders
  },
  {
    icon: 'outlined/reviews',
    name: 'Отзывы о\xA0товарах',
    path: Page.AdminReviews,
    userPermission: UserPermission.GetReviewsAsAdmin
  },
  {
    icon: 'outlined/live-help',
    name: 'Вопросы о\xA0товарах',
    path: Page.AdminProductQuestions,
    userPermission: UserPermission.AdminGetProductQuestions
  },
  {
    icon: 'outlined/tag-outline',
    name: 'Теги',
    path: Page.AdminTags
  },
  {
    icon: 'outlined/folder',
    name: 'Подборки',
    path: Page.AdminCollections,
    userPermission: UserPermission.GetCollectionsAsAdmin
  },
  {
    icon: 'outlined/gift-outline',
    name: 'Акции',
    path: Page.AdminSpecialOffers,
    userPermission: UserPermission.GetSpecialOffersAsAdmin
  },
  {
    icon: 'outlined/article',
    name: 'Статьи',
    path: Page.AdminArticles,
    userPermission: UserPermission.GetArticlesAsAdmin
  },
  {
    icon: 'outlined/view-carousel',
    name: 'Баннеры',
    path: Page.AdminBanners,
    userPermission: UserPermission.AdminGetBanners
  },
  {
    icon: 'outlined/message',
    name: 'Сообщения',
    path: Page.AdminMessages,
    userPermission: UserPermission.GetMessages
  },
  {
    icon: 'outlined/ticket-percent-outline',
    name: 'Промокоды',
    path: Page.AdminPromoCodes,
    userPermission: UserPermission.GetPromoCodes
  },
  {
    icon: 'outlined/ticket-percent-outline',
    name: 'Заявки на\xA0промокод',
    path: Page.AdminPromoCodeApplications,
    userPermission: UserPermission.GetPromoCodeApplications
  },
  {
    icon: 'outlined/card-giftcard',
    name: 'Сертификаты',
    path: Page.AdminCertificates,
    userPermission: UserPermission.GetCertificates
  },
  {
    icon: 'outlined/warehouse',
    name: 'Склады',
    path: Page.AdminWarehouses,
    userPermission: UserPermission.GetWarehouses
  },
  {
    icon: 'outlined/payments',
    name: 'Заявки на\xA0вывод средств',
    path: Page.AdminWithdrawals,
    userPermission: UserPermission.GetWithdrawals
  },
  {
    icon: 'outlined/verified',
    name: 'Сертификаты качества',
    path: Page.AdminQualityCertificates,
    userPermission: UserPermission.AdminGetQualityCertificates
  },
  {
    icon: 'outlined/tag-outline',
    name: 'Сбор скидок',
    path: Page.AdminDiscounts,
    userPermission: UserPermission.AdminGetLayerSpecialOffers
  },
  {
    icon: 'outlined/analytics',
    name: 'Аналитика',
    path: Page.AdminAnalytics
  },
  {
    icon: 'outlined/terminal',
    name: 'Скрипты',
    path: Page.AdminScripts
  }
]
const adminAnalytics: MenuItem[] = [
  {
    icon: 'outlined/analytics',
    modalWindow: ExportSalesStatistics,
    modalWindowProps: { authScope: AuthScope.Admin },
    name: 'Продажи',
    userPermission: UserPermission.AdminExportSalesStatistics
  },
  {
    icon: 'outlined/analytics',
    modalWindow: ExportOrdersStatistics,
    name: 'Заказы',
    userPermission: UserPermission.AdminExportOrdersStatistics
  },
  {
    icon: 'outlined/analytics',
    modalWindow: ExportPaidOrdersAndUsersStatistics,
    name: 'Оплаченные заказы и пользователи',
    userPermission: UserPermission.AdminExportPaidOrdersAndUsersStatistics
  },
  {
    icon: 'outlined/analytics',
    modalWindow: ExportIncreasedRatesStatistics,
    modalWindowProps: { authScope: AuthScope.Admin },
    name: 'Повышенные проценты',
    userPermission: UserPermission.AdminExportIncreasedRatesStatistics
  }
]
const adminScripts: MenuItem[] = [
  {
    icon: 'outlined/terminal',
    modalWindow: UpdateProductPositions,
    name: 'Обновление позиций товаров'
  },
  {
    icon: 'outlined/terminal',
    modalWindow: UpdateBrandPositions,
    name: 'Обновление позиций брендов'
  },
  {
    icon: 'outlined/terminal',
    modalWindow: UpdateThisWeekDiscounts,
    name: 'Обновление скидок этой недели'
  }
]
const catalog: CatalogMenuItem[] = [
  // { class: 'black-friday', name: 'Чёрная пятница', path: `${Page.Categories}chyornaya-pyatnitsa-77/` },
  // { class: 'sale1111', name: 'РАСПРОДАЖА 11.11', path: `${Page.Categories}rasprodazha-1111-208/` },
  // { class: 'sale1111', name: sale1111.name, path: sale1111.path },
  // { name: 'Для детей', path: `${Page.Categories}dlya-detey-87/` },
  // { name: 'Красота', path: `${Page.Categories}krasota-85/` },
  // { name: forAnimals.name, path: forAnimals.path },
  { name: 'Женское здоровье', path: `${Page.Categories}zhenskoe-zdorove-123/` },
  { name: 'Детокс', path: `${Page.Categories}detoksikatory-39/` },
  // { name: 'Диагностика', path: `${Page.Categories}diagnostika-143/` },
  // { name: 'В подарок', path: `${Page.Categories}v-podarok-146/` },
  { name: 'Печень', path: `${Page.Categories}pechen-i-zhelchnyy-134/` },
  { name: 'ЖКТ', path: `${Page.Categories}mikrobiota-i-zhkt-112/` },
  { name: 'Стресс', path: `${Page.Categories}nervnaya-sistema-109/` }
]
const contacts: MenuItem[] = [
  {
    icon: 'filled/phone',
    modalWindow: ContactUs,
    modalWindowProps: { isCallUs: true },
    name: 'Позвонить нам'
  },
  { icon: 'outlined/email', modalWindow: ContactUs, name: 'Написать нам' }
]
const products: HorizontalMenuItem[] = [
  // { class: 'pink', name: motherDay.name, path: motherDay.path },
  // { class: 'sale1111', name: sale1111.name, path: sale1111.path },
  // { class: 'green', isUppercase: true, name: greenFriday.name, path: greenFriday.path },
  // { name: octoberFest.name, path: octoberFest.path },
  // { backgroundColor: 'black', color: 'white', name: blackFriday.name, path: blackFriday.path },
  { name: groceries.name, path: groceries.path },
  { name: peptides.name, path: peptides.path },
  { name: 'Косметика', path: `${Page.Categories}kosmetika-209/` },
  { name: forAnimals.name, path: forAnimals.path },
  { name: 'Бытовая нехимия', path: `${Page.Categories}bytovaya-nehimiya-193/` },
  { class: 'iherb', name: iherb.name, path: iherb.path }
  // { class: 'green', name: beautyAndFashion.name, path: beautyAndFashion.path },
  // { backgroundColor: '#fcc800', color: '#404e5e', name: sunnySummer.name, path: sunnySummer.path },
  // { backgroundColor: '#e84665', color: 'white', name: summerEnergy.name, path: summerEnergy.path },
  // { backgroundColor: '#ffa37d', color: 'white', name: sportWeek.name, path: sportWeek.path },
  // { backgroundColor: '#ff887c', color: 'white', name: detoxWeek.name, path: detoxWeek.path },
  // { backgroundColor: '#4ebf3a', color: 'white', name: healthWeek.name, path: healthWeek.path },
  // { backgroundColor: '#fd56a6', color: 'white', name: beautyWeek.name, path: beautyWeek.path },
  // { backgroundColor: '#b87aff', color: 'white', name: sweetLife.name, path: sweetLife.path },
  // { backgroundColor: '#78b7ff', color: 'white', name: onFebruary23rd.name, path: onFebruary23rd.path },
  // { class: 'red', name: newYearMiracle.name, path: newYearMiracle.path },
  // { class: 'pink', name: valentinesDay.name, path: valentinesDay.path },
  // { class: 'pink', name: womensWeek.name, path: womensWeek.path },
  // { backgroundColor: '#ff6b09', color: 'white', name: pancakeWeek.name, path: pancakeWeek.path },
  // { backgroundColor: '#fcc800', color: '#4e301d', name: bestForChildren.name, path: bestForChildren.path },
  // { class: 'blue', name: againstSars.name, path: againstSars.path },
  // { name: 'Гигиена', path: `${Page.Categories}gigiena-184/` },
  // { name: ourProducts.name, path: ourProducts.path },
  // { name: consultations.name, path: consultations.path },
  // { name: thisWeekDiscounts.name, path: thisWeekDiscounts.path },
  // { name: 'Новинки', path: `${Page.Products}?sort=newest` },
  // { name: 'Подборки специалистов', path: Page.Collections }
]
const specialist: MenuItem[] = [
  { icon: 'outlined/list-alt', name: 'Списки', path: Page.AccountLists },
  {
    icon: 'outlined/question-answer',
    name: 'Консультации',
    path: Page.SpecialistConsultations,
    userPermission: UserPermission.SpecialistGetConsultations
  },
  { icon: 'outlined/recommend', name: 'Рекомендации', path: Page.SpecialistRecommendations },
  {
    icon: 'outlined/ticket-percent-outline',
    isUsualLink: true,
    name: 'Скидки в\xA0лабораториях',
    path: constants.documentUrls.coupons
  },
  { icon: 'outlined/people', name: 'Заявка в\xA0каталог специалистов', path: Page.SpecialistProfile }
]
const supplier: MenuItem[] = [
  {
    icon: 'outlined/widgets',
    name: 'Анкеты на товары',
    path: Page.SupplierProducts,
    userPermission: UserPermission.SupplierGetProducts
  },
  { icon: 'outlined/branding-watermark', name: 'Бренды', path: Page.SupplierBrands },
  {
    icon: 'outlined/tag-outline',
    name: 'Сбор скидок',
    path: Page.SupplierDiscounts,
    userPermission: UserPermission.SupplierGetLayerSpecialOffers
  },
  {
    icon: 'outlined/live-help',
    name: 'Вопросы о\xA0товарах',
    path: Page.SupplierProductQuestions,
    userPermission: UserPermission.SupplierGetProductQuestions
  },
  {
    icon: 'outlined/reviews',
    name: 'Отзывы на\xA0товары',
    path: Page.SupplierReviews,
  },
  {
    icon: 'outlined/article',
    name: 'Заявки на\xA0поставку',
    path: Page.SupplierSupplyOrders,
    userPermission: UserPermission.SupplierGetSupplyOrders
  },
  { icon: 'outlined/verified', name: 'Сертификаты качества', path: Page.SupplierQualityCertificates },
  { icon: 'outlined/analytics', name: 'Аналитика', path: Page.SupplierAnalytics },
  {
    icon: 'outlined/store',
    name: 'Сведения о\xA0компании',
    path: Page.SupplierAccount,
    userPermission: UserPermission.SupplierGetSupplierAccount
  }
]
const supplierAnalytics: MenuItem[] = [
  {
    icon: 'outlined/analytics',
    modalWindow: ExportSalesStatistics,
    modalWindowProps: { authScope: AuthScope.Supplier },
    name: 'Продажи',
    userPermission: UserPermission.SupplierExportSalesStatistics
  },
  {
    icon: 'outlined/analytics',
    modalWindow: ExportIncreasedRatesStatistics,
    modalWindowProps: { authScope: AuthScope.Supplier },
    name: 'Повышенные проценты',
    userPermission: UserPermission.SupplierExportIncreasedRatesStatistics
  }
]

export default {
  account,
  admin,
  adminAnalytics,
  adminScripts,
  catalog,
  contacts,
  products,
  specialist,
  supplier,
  supplierAnalytics
}
